
import { Component} from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
import { ListProveedorComponent } from './list-proveedor/list-proveedor.component';
import { MessagesStatus, MessagesTitles } from 'app/models/messages';

@Component({
  selector: 'app-proveedores',
  templateUrl: './proveedores.component.html',
  styleUrls: ['./proveedores.component.scss'],
  providers:[ListProveedorComponent,MessagesTitles, MessagesStatus]
})
export class ProveedoresComponent{
  desbloqueoMasivo : boolean=false;
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  constructor(
    private loginService: LoginService,
    private listado:ListProveedorComponent) {
    }


  clickGuard(){
    this.loginService.clickGuard = true;
 }
 AbrirPopupDesbloqueo(){
  this.desbloqueoMasivo = true;
}
CerrarPopupDesbloqueo(){
  this.desbloqueoMasivo = false;
  this.listado.cargarListado();
}

}